import {
  isAfter,
  isBefore,
  parseISO,
} from 'date-fns'

export default function isLive(startTime, endTime) {
  const curDate = new Date()
  const parsedStartTime = parseISO(startTime)
  const parsedEndTime = parseISO(endTime)

  if (isAfter(curDate, parsedStartTime) && isBefore(curDate, parsedEndTime)) {
    return true
  }
  return false
}
